import {createSelector, Selector} from '@reduxjs/toolkit';

import {TLookupValue} from 'modules/data/data-types';
import {TAppState} from 'store/config/types';

import {DOCUMENTS_SLICE} from './constants';
import {
    IDocumentProperty,
    IDocumentsState,
    IDocumentTypeResponse,
    IFileUploadState,
    ISignatureUploadState,
} from './types';

const rootSelector: Selector<TAppState, IDocumentsState> = (state: TAppState) => state[DOCUMENTS_SLICE];

export const selectDocumentsForUploadAttach = createSelector(
    [rootSelector, (_, sublistCode: string) => sublistCode],
    ({documentsForUploadAttach}, sublistCode: string) => documentsForUploadAttach?.[sublistCode],
);

export const selectDocumentTypeOnUpload: Selector<TAppState, IDocumentTypeResponse[] | undefined> = createSelector(
    rootSelector,
    ({documentTypesOnUpload}: IDocumentsState) => documentTypesOnUpload,
);

export const selectDocumentTypes: Selector<TAppState, IDocumentTypeResponse[] | undefined> = createSelector(
    rootSelector,
    ({documentTypes}: IDocumentsState) => documentTypes,
);

export const selectDocumentBranchNames: Selector<TAppState, IDocumentTypeResponse[] | undefined> = createSelector(
    rootSelector,
    ({branchNames}: IDocumentsState) => branchNames,
);

export const selectDocumentProperties: Selector<TAppState, IDocumentProperty | undefined> = createSelector(
    rootSelector,
    ({documentProperties}: IDocumentsState) => documentProperties,
);

export const selectDocumentsSigningMethod = createSelector(
    rootSelector,
    ({signingMethod}: IDocumentsState) => signingMethod,
);

export const selectDocumentFileUpload: Selector<TAppState, IFileUploadState> = createSelector(
    rootSelector,
    ({fileUpload}: IDocumentsState) => fileUpload,
);

export const selectDocumentSignatureUpload: Selector<TAppState, ISignatureUploadState> = createSelector(
    rootSelector,
    ({signatureUpload}: IDocumentsState) => signatureUpload,
);

export const selectDocumentExtensions = createSelector(
    rootSelector,
    ({signatureExtensions}: IDocumentsState) => signatureExtensions,
);

export const selectDocumentList: Selector<
  TAppState,
  TLookupValue[] | IDocumentTypeResponse[] | undefined> = createSelector(
      rootSelector,
      ({documentList}: IDocumentsState) => documentList,
  );

export const selectDocumentFileUploadByEntityName = (entityName: string) => createSelector(
    rootSelector,
    ({fileUpload}: IDocumentsState) => fileUpload[entityName],
);

export const selectDocumentSignatureUploadByEntityName = (entityName: string) => createSelector(
    rootSelector,
    ({signatureUpload}: IDocumentsState) => signatureUpload[entityName],
);

export const selectDocumentsUploadMonitoring = () => createSelector(
    rootSelector,
    ({documentsUploadMonitoring}: IDocumentsState) => documentsUploadMonitoring,
);

export const selectDocumentsPagination = createSelector(
    rootSelector,
    ({pagination}: IDocumentsState) => pagination,
);
